<template>
  <v-container class="feedback-page uf-journey">
    <div class="feedback-brand"><img src="@/assets/logo/petmeetly-text-color.png" alt="Petmeetly" height="44" /></div>
    <user-feedback-dialog v-if="!loading && !error && !done && yes" ref="feedback" embedded />
    <v-card v-else class="feedback-surface uf-surface" outlined>
      <section class="uf-journey-thanks" :role="done ? 'status' : undefined">
        <v-progress-linear v-if="loading" indeterminate />
        <template v-else>
          <div v-if="done" class="uf-thanks-icon"><v-icon size="42">mdi-check-circle-outline</v-icon></div>
          <h1>{{ done ? (stop ? 'Status check-ins stopped' : 'Thank you for the update') : 'Your status update' }}</h1>
          <template v-if="details">
            <p>{{ message }}</p>
            <v-btn v-if="!done && stop" depressed color="primary" class="uf-journey-action mt-4" :loading="saving" :disabled="saving || asking" @click="confirm()">Stop Status Check-ins</v-btn>
          </template>
          <feedback-error v-if="error" title="We couldn’t complete your status update" :message="error" />
        </template>
      </section>
    </v-card>
  </v-container>
</template>
<script>
import FeedbackError from '../components/FeedbackError.vue';
import '../../styles/user-feedback.scss';
import UserFeedbackDialog from '../components/UserFeedbackDialog.vue';
import {journeyClient, failure, reportFeedbackFailure, feedbackOptions} from '../../utils/userFeedback';
export default {
  components: {FeedbackError, UserFeedbackDialog},
  data: () => ({token:'',details:null,loading:true,saving:false,asking:false,done:false,error:''}),
  metaInfo:{title:'Your status update',meta:[{name:'robots',content:'noindex,nofollow,noarchive'},{name:'referrer',content:'no-referrer'}]},
  computed:{
    yes(){return this.details && this.details.answer === 'y';},
    stop(){return this.details && this.details.answer === 'b';},
    message(){
      if(this.stop) return this.done ? 'We won’t send any more status check-ins for ' + this.details.name + '.' : 'Stop status check-ins for ' + this.details.name + '?';
      if(!this.details.active) return this.details.name + ' is hidden. You can make it active again from your account.';
      if(this.yes) return this.done ? 'Your feedback has been saved. Your listing is still active.' : 'Share your experience and choose whether to keep ' + this.details.name + ' active.';
      return '';
    }
  },
  async mounted(){
    try { this.token=decodeURIComponent(window.pmFeedbackToken || window.location.hash.slice(1)); } catch(e) { this.loading=false;this.error='This check-in link is invalid. Please open the link in your email.';return; }
    delete window.pmFeedbackToken;
    window.history.replaceState(null,'',window.location.pathname);
    if(!this.token){this.loading=false;this.error='Please open the private check-in link in your email.';return;}
    try {const {data}=await journeyClient.post('/status/open',{token:this.token});this.details=data.answer === 'y' ? feedbackOptions(data) : data;this.done=this.yes && data.done || this.stop && data.blocked;this.loading=false;if(data.answer === 'n'){window.location.replace('/home');return;}if(!this.done && this.yes){await this.$nextTick();await this.ask();}}
    catch(e){reportFeedbackFailure('status.request',e);this.error=failure(e);}finally{this.loading=false;}
  },
  methods:{
    async ask(){
      if(this.asking)return;this.asking=true;
      try {
        const result=await this.$refs.feedback.ask({statusContext:this.details,petXid:this.details.pets.length ? this.details.pets[0].xid : null,
          submitStatus:body=>{body.append('token',this.token);return journeyClient.post('/status/respond',body);}});
        if(result){this.details=result;this.done=true;}
      }finally{this.asking=false;}
    },
    async confirm(){
      if(this.saving)return;this.saving=true;this.error='';
      try {const {data}=await journeyClient.post('/status/respond',{token:this.token,hide:false});this.details=data;this.done=true;}
      catch(e){reportFeedbackFailure('status.request',e);this.error=failure(e);}finally{this.saving=false;}
    }
  }
};
</script>
